import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { track } from '../../analytics';
import { IDS } from '../../automationTestIds';

export const DeliveryHeader = ({
  zipCode,
  showCheckAvailability,
  setShowCheckAvailability,
  isCartTiles
}) => {

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowCheckAvailability(!showCheckAvailability);
    track('click', {
      origin: 'delivery-options',
      eventName: 'check fulfillment availability',
      primaryCategory: 'button submission'
    });
  };

  const availabilityButton = (
    <button
      type="button"
      className="u__default-link"
      role="link"
      onClick={handleOnClick}
      data-testid="delivery-header-zipcode-link"
    >
      { zipCode }
    </button>
  );

  return (
    <div className="fulfillment__header delivery__header" data-automation-id={IDS.LABEL.deliveryToLabel}>
      <span>
        Delivering to { isCartTiles ? zipCode : availabilityButton }
      </span>
    </div>
  );
};

DeliveryHeader.propTypes = {
  zipCode: PropTypes.string.isRequired,
  showCheckAvailability: PropTypes.bool.isRequired,
  setShowCheckAvailability: PropTypes.func.isRequired,
  isCartTiles: PropTypes.bool
};

DeliveryHeader.defaultProps = {
  isCartTiles: false
};
